"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: 1,
  question: "What does Tax Fee Protection Insurance cover?",
  answer: "Our comprehensive policy covers Corporation Tax, Income Tax, VAT, PAYE/NIC, IR35 enquiries, Code of Practice 8 investigations, and more. The cover includes professional fees for handling HMRC enquiries, providing peace of mind for your business."
}, {
  id: 2,
  question: "How does the claims process work?",
  answer: "When you receive an HMRC enquiry, simply notify us immediately. Our experienced claims team will guide you through the process, working with your accountant to handle the enquiry efficiently. We cover professional fees up to the policy limit."
}, {
  id: 3,
  question: "Who can benefit from Fee Protection Insurance?",
  answer: "Any business or individual who submits tax returns can benefit from our protection. This includes sole traders, partnerships, limited companies, and personal tax clients. Your accountant can arrange cover on your behalf."
}, {
  id: 4,
  question: "What additional services are included?",
  answer: "Beyond insurance coverage, we provide tax and VAT telephone advice, tailored marketing support, specialist consultancy, and access to employment, health & safety, and legal advice services through our partnerships."
}, {
  id: 5,
  question: "How much does the insurance cost?",
  answer: "Insurance premiums vary based on your business type, turnover, and the level of cover required. Contact us for a personalized quote tailored to your specific circumstances and risk profile."
}, {
  id: 6,
  question: "Are there any exclusions to the policy?",
  answer: "Standard exclusions apply, including pre-existing enquiries, deliberate non-disclosure, fraud, and certain criminal investigations. Full policy terms and conditions are available upon request and will be provided with your quote."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return;
}